<template>
<div :class="$style['select-active-list']">
    <pt-page-factor-filter :labels="typeTabs" v-model="params">
        <el-button type="primary" @click="filter">筛选</el-button>
    </pt-page-factor-filter>
    <pt-radio-list ref="table"  :page-size="pageSize" :table-data="tableData" :tableLabels="tableLabels"   @getTableData="getTableData" :total-count="totalNumber"  @selected="selected">
    </pt-radio-list>
    <div class="button-div" v-if="isSubmit">
        <el-button type="primary" @click="submit" :loading="loading">选择</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
</div>
</template>
<script>
import ptRadioList from 'cps/base/pt-radio-list'
import { selectPromotionLabels, selectLisTab } from './active-option'
export default {
  components: {
    ptRadioList
  },
  data () {
    return {
      pageSize: 5,
      tableData: [],
      tableLabels: selectPromotionLabels,
      totalNumber: 0,
      typeTabs: selectLisTab,
      params: {},
      paramsData: {
        status: 'ACTIVATED'
      },
      selectRow: {},
      loading: false
    }
  },
  props: {
    isSubmit: {
      type: Boolean,
      default: true
    },
    selectPromotion: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    submit () {
      this.promotionBannerUrl()
    },
    filter () {
      for (let key in this.params) {
        if (!this.params[key]) {
          this.$delete(this.params, key)
        }
      }
      //   this.paramsData = { promotionData: this.params, ...this.paramsData }
      //   this.paramsData = JSON.parse(JSON.stringify(this.params))
      this.getTableData(0).then(this.$refs.table.reset())
    },
    selected (val) {
      this.selectRow = JSON.parse(JSON.stringify(val))
      this.$emit('selectPromotion', this.selectRow)
    },
    promotionBannerUrl () {
      let data = {
        promotionEventId: this.selectRow.id,
        bannerType: 'POPUP'
      }
      this.loading = true
      this.$store.dispatch('promotionBannerUrl', data).then(res => {
        this.$emit('submitActive', res)
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取活动信息失败')
      })
    },
    getTableData (page, next) {
      let data = {
        ...this.params,
        example: {
          ...this.paramsData
        },
        pageableParam: {
          page: page,
          size: this.pageSize
        }
      }
      this.loading = true
      return this.$store.dispatch('getPromotionList', data).then(res => {
        this.loading = false
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取促销活动列表失败')
      })
    }
  }
}
</script>
<style module lang="less">
.select-active-list{
    :global
    .button-div{
        padding: 0
    }
}
</style>
